import React from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Form,
} from "reactstrap"

// Formik Validation
import { Link } from "react-router-dom"
import { withRouter, useHistory } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

// actions
import "../../assets/scss/custom/style.css"

import Snackbars from "../../Utils/Snackbars"
import useRequests from "../../Utils/useRequests"
import i18next from "i18next"

const Kyc = () => {
  //meta title
  document.title = i18next.t("KYC_Verification PG document title")
  const { getRequest, postRequest } = useRequests()
  const history = useHistory()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const [notifications, setNotifications] = React.useState("")
  const handleLoadGetNotifications = async () => {
    const res = await getRequest("get-notifications")
    if (res && res.code === 200) {
      let filteredData = res.data.filter(item => item.deleted_at == null)
      setNotifications(filteredData)
    } else {
      setNotifications([])
    }
    resetAlertData()
  }

  const handleNotificationAction = async (e, note) => {
    const jsonpar = JSON.stringify({
      n_id: note.n_id,
    })
    const res = await postRequest("update-notification", jsonpar)
    if (res && res.code === 200) {
      await handleLoadGetNotifications()
    }

    if (note.redirect_link) {
      history.push(note.redirect_link)
    }
  }

  const handleAllNotificationAction = async () => {
    const res = await getRequest("update-all-notification")
    if (res && res.code === 200) {
      await handleLoadGetNotifications()
    }
  }

  const handleClearAllNotifications = async () => {
    const res = await getRequest("delete-all-notification")
    if (res && res.code === 200) {
      await handleLoadGetNotifications()
    }
  }

  React.useEffect(() => {
    handleLoadGetNotifications()
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="page-content common-width">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb
            title={i18next.t("PG title Tokenizedgreen")}
            breadcrumbItem={i18next.t("PG breadcrumbItem Notification")}
          />
          <Row>
            <Col xs="12">
              <div className="sidebar">
                <ul>
                  <li>
                    <Link to="/dashboard">
                      <i className="bx bx-home-circle"></i>{" "}
                      {i18next.t("Menu Dashboard")}
                    </Link>
                  </li>
                  {localStorage.getItem("Collaborator") == "true" ? (
                    <li>
                      <Link to="/collaborator">
                        <i className="fas fa-handshake"></i>{" "}
                        {i18next.t("Collaborator")}
                      </Link>
                    </li>
                  ) : (
                    ""
                  )}
                  <li>
                    <Link to="/wallet">
                      <i className="bx bx-wallet-alt"></i>{" "}
                      {i18next.t("Menu My Wallet")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/properties">
                      <i className="bx bx-shopping-bag"></i>{" "}
                      {i18next.t("Menu Browse Property")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/portfolio">
                      <i className="bx bx-cart-alt"></i>{" "}
                      {i18next.t("Menu My Portfolio")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/claimed-fund">
                      <i className="bx bx-money"></i>{" "}
                      {i18next.t("Menu My Claimed Fund")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/mytransaction">
                      <i className="bx bx-list-ul"></i>{" "}
                      {i18next.t("Menu My Transaction")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/Kyc" className="active">
                      <i className="bx bx-user-check"></i>{" "}
                      {i18next.t("Menu KYC Verification")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/twofaauthenticator">
                      <i className="bx bx-key"></i>{" "}
                      {i18next.t("Menu 2FA Authenticator")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/dividends">
                      <i className="bx bx-wallet-alt"></i>{" "}
                      {i18next.t("Menu Dividends")}
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="contentt">
                <Row>
                  <Col lg="12">
                    <Row className="align-items-center mb-4">
                      <Col className="text-end">
                        <Button
                          color="success"
                          size="sm"
                          onClick={handleAllNotificationAction}
                          style={{
                            backgroundColor: "#29662f",
                            borderRadius: "6px",
                            fontWeight: "500",
                            padding: "6px 12px",
                            marginRight: "8px",
                          }}
                        >
                          {i18next.t("Mark All as Read")}
                        </Button>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={handleClearAllNotifications}
                          style={{
                            backgroundColor: "red",
                            borderRadius: "6px",
                            fontWeight: "500",
                            padding: "6px 12px",
                          }}
                        >
                          {i18next.t("Clear All")}
                        </Button>
                      </Col>
                    </Row>

                    {notifications.length === 0 ? (
                      <Card>
                        <CardBody>
                          <p className="text-center">
                            {i18next.t("No Notifications")}
                          </p>
                        </CardBody>
                      </Card>
                    ) : (
                      notifications.map((note, index) => (
                        <Card
                          key={note.n_id || index}
                          className="mb-3 shadow-sm"
                          style={{
                            borderLeft:
                              note.read == "false"
                                ? "4px solid red"
                                : "4px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={e => handleNotificationAction(e, note)}
                        >
                          <CardBody className="d-flex align-items-start">
                            {/* Read/Unread Dot */}
                            <span
                              style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "50%",
                                backgroundColor:
                                  note.read == "true" ? "#ccc" : "red",
                                display: "inline-block",
                                marginRight: "10px",
                                marginTop: "6px",
                                flexShrink: 0,
                              }}
                            ></span>

                            {/* Notification Content */}
                            <div style={{ flex: 1 }}>
                              <h6
                                className="mb-1"
                                style={{
                                  fontWeight:
                                    note.read == "true" ? "normal" : "600",
                                  fontSize: "14px",
                                }}
                              >
                                {localStorage.getItem("I18N_LANGUAGE")=="eng"?note.subject:note.subject_sp}
                              </h6>

                              <p
                                className={`alert ${
                                  note.read == "true"
                                    ? "alert-secondary"
                                    : "alert-success"
                                } successfullyKYC`}
                                style={{ margin: "6px 0" }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    localStorage.getItem("I18N_LANGUAGE")=="eng"?note.description:note.description_sp ||
                                    i18next.t(
                                      "KYC_Verification PG Approved P1",
                                    ),
                                }}
                              />

                              {note.created_at && (
                                <small className="text-muted">
                                  {new Date(note.created_at).toLocaleString()}
                                </small>
                              )}
                            </div>
                          </CardBody>
                        </Card>
                      ))
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Kyc)
